import { useMutation, useQueryClient } from 'react-query'

import { ACCOUNT_GROUPS_QUERY_KEY } from 'features/account-create/hooks/use-account-groups'
import type {
  AccountsService,
  CreateAccountGroupInput,
} from 'features/accounts/service'
import type { AccountGroup } from 'features/accounts/types'

type UseCreateAccountGroupResult = {
  createAccountGroup: (input: CreateAccountGroupInput) => Promise<AccountGroup>
  isCreating: boolean
}

export function useCreateAccountGroup(
  service: AccountsService,
): UseCreateAccountGroupResult {
  const queryClient = useQueryClient()
  const mutation = useMutation<AccountGroup, Error, CreateAccountGroupInput>(
    (input) => service.createAccountGroup(input),
    {
      onSuccess: () => {
        void queryClient.invalidateQueries([ACCOUNT_GROUPS_QUERY_KEY])
      },
    },
  )
  return {
    createAccountGroup: (input) => mutation.mutateAsync(input),
    isCreating: mutation.isLoading,
  }
}
